import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2, Apple } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'EL NUEVO PARADIGMA',
  desc: 'Del profesional que vende horas al dueño de un sistema. Configuración del ecosistema digital en 24 horas. Plan de acción de 30 días.',
  color: 'text-electric',
  bg: 'bg-electric/10',
  border: 'border-electric',
  shadow: 'shadow-[0_0_20px_rgba(125,255,47,0.5)] hover:shadow-[0_0_35px_rgba(125,255,47,0.85)]'
}, {
  num: '2',
  title: 'EL MOTOR DE PRODUCCIÓN',
  desc: 'Protocolo de 8 pasos para crear planes con IA. Biblioteca de prompts por objetivo y patología. Checklist de revisión profesional.',
  color: 'text-energy',
  bg: 'bg-energy/10',
  border: 'border-energy',
  shadow: 'shadow-[0_0_20px_rgba(168,255,96,0.5)] hover:shadow-[0_0_35px_rgba(168,255,96,0.85)]'
}, {
  num: '3',
  title: 'EL PRODUCTO DE ÉLITE',
  desc: 'Cómo empaquetar tu servicio como producto premium. Modelo de precios de 3 niveles. Página de ventas que convierte.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(232,184,74,0.5)] hover:shadow-[0_0_35px_rgba(232,184,74,0.85)]'
}, {
  num: '4',
  title: 'LA FÁBRICA DE ATENCIÓN',
  desc: 'Sistema de contenido para Instagram que atrae clientes sin pauta. Calendario editorial de 30 días. Tarde de Producción mensual.',
  color: 'text-electric',
  bg: 'bg-electric/10',
  border: 'border-electric',
  shadow: 'shadow-[0_0_20px_rgba(125,255,47,0.5)] hover:shadow-[0_0_35px_rgba(125,255,47,0.85)]'
}, {
  num: '5',
  title: 'EL SISTEMA DE CONVERSIÓN',
  desc: 'Protocolo de cierre por DM y WhatsApp. Secuencia de 5 emails que vende en automático. Respuestas exactas para las 8 objeciones más comunes.',
  color: 'text-energy',
  bg: 'bg-energy/10',
  border: 'border-energy',
  shadow: 'shadow-[0_0_20px_rgba(168,255,96,0.5)] hover:shadow-[0_0_35px_rgba(168,255,96,0.85)]'
}, {
  num: '6',
  title: 'EL SALTO DE ESCALA',
  desc: 'Las 8 automatizaciones esenciales. Modelo de membresía recurrente. Delegación inteligente. Publicidad paga para escalar lo que funciona.',
  color: 'text-gold',
  bg: 'bg-gold/10',
  border: 'border-gold',
  shadow: 'shadow-[0_0_20px_rgba(232,184,74,0.5)] hover:shadow-[0_0_35px_rgba(232,184,74,0.85)]'
}];
const inclusions = ['Prompts de IA listos para copiar y pegar', 'Checklists, tablas y plantillas accionables', 'Diseñado para el mercado hispanohablante', 'Aplicable desde el primer día sin experiencia técnica'];
export function TomosSection() {
  return <section className="py-14 bg-petroleum/30 border-y border-electric/10" data-id="element-551">
      <div className="container mx-auto px-4" data-id="element-552">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto mb-16" data-id="element-553">
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-554">
            {/* Decorative apple flourish in background */}
            <div className="absolute -top-20 -right-20 opacity-10 pointer-events-none rotate-12" data-id="element-555">
              <Apple className="w-56 h-56 text-electric" data-id="element-556" />
            </div>
            <div className="absolute -bottom-20 -left-20 opacity-10 pointer-events-none -rotate-12" data-id="element-557">
              <Apple className="w-56 h-56 text-electric" data-id="element-558" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-559"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-560"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-561"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-562"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-563"></div>

            <div className="relative z-10" data-id="element-564">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite font-extrabold tracking-widest uppercase text-xs px-4 py-1.5 rounded-full mb-5 shadow-lg shadow-electric/40" data-id="element-565">
                <Apple className="w-3.5 h-3.5" data-id="element-566" />
                El Sistema Completo
                <Apple className="w-3.5 h-3.5" data-id="element-567" />
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-568">
                🏆 NEGOCIO FITNESS IA:
                <br data-id="element-569" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-570">
                  EL SISTEMA ESCALABLE
                </span>
              </h2>
              <div className="mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70 mb-5" data-id="element-571"></div>
              <p className="text-base md:text-lg text-textsecondary mb-5" data-id="element-572">
                De 0 a Negocio Digital Escalable.
              </p>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm md:text-base" data-id="element-573">
                <span className="inline-flex items-center gap-1.5 bg-electric/10 border border-electric/30 text-white font-bold rounded-full px-3.5 py-1" data-id="element-574">
                  6 Tomos
                </span>
                <span className="text-electric/50" data-id="element-575">+</span>
                <span className="inline-flex items-center gap-1.5 bg-electric/10 border border-electric/30 text-white font-bold rounded-full px-3.5 py-1" data-id="element-576">
                  6 Bonos
                </span>
                <span className="text-electric/50" data-id="element-577">·</span>
                <span className="inline-flex items-center gap-1.5 bg-electric/10 border border-electric/30 text-white font-bold rounded-full px-3.5 py-1" data-id="element-578">
                  450+ páginas
                </span>
              </div>
              <p className="mt-4 text-sm md:text-base text-electric font-semibold tracking-wide uppercase" data-id="element-579">
                Todo resuelto.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-580">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-petroleum rounded-2xl p-6 border-2 ${tomo.border} ${tomo.shadow} transition-all duration-300 group relative overflow-hidden hover:-translate-y-1`} data-id="element-581">
              <div className={`absolute top-0 right-0 w-32 h-32 ${tomo.bg} blur-3xl rounded-full -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50`} data-id="element-582"></div>

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-583">
                <div className={`w-12 h-12 rounded-xl ${tomo.bg} ${tomo.color} flex items-center justify-center font-bold text-xl`} data-id="element-584">
                  {tomo.num}
                </div>
                <BookOpen className={`w-6 h-6 ${tomo.color} opacity-50`} data-id="element-585" />
              </div>

              <h3 className="text-lg font-bold mb-3 relative z-10" data-id="element-586">
                Tomo {tomo.num} — {tomo.title}
              </h3>
              <p className="text-textsecondary text-sm leading-relaxed relative z-10" data-id="element-587">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="max-w-3xl mx-auto bg-graphite rounded-2xl p-8 border border-electric/20" data-id="element-588">
          <h4 className="text-center font-bold text-xl mb-6" data-id="element-589">
            Cada tomo incluye:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-590">
            {inclusions.map((inc, i) => <div key={i} className="flex items-start gap-3" data-id="element-591">
                <CheckCircle2 className="w-5 h-5 text-electric shrink-0 mt-0.5" data-id="element-592" />
                <span className="text-textsecondary text-sm" data-id="element-593">{inc}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}